// extracted by mini-css-extract-plugin
module.exports = {"clickable":"_1kIwI"};